import { render, staticRenderFns } from "./portaus-link.vue?vue&type=template&id=146340e8&"
import script from "./portaus-link.vue?vue&type=script&lang=js&"
export * from "./portaus-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports